<template>
  <div class="web-footer">
    <div class="web-footer_content">
      <span>主办单位：包头市市场监督管理局</span>
      <span>版权所有：包头市市场监督管理局</span>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.web-footer{
  position: relative;
  background: #1369c1;
  color: #fff;
  padding: 10px;
  min-height: 60px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.web-footer::before,
.web-footer::after{
  content: '';
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(19, 105, 193, .3);
}
.web-footer::before{
  bottom: 8px;
}
.web-footer::after{
  bottom: 16px;
}
.web-footer_content{
  position: relative;
  z-index: 1;
}
.web-footer_content span{
  padding: 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue